import React, { useCallback, useEffect, useState } from 'react';
import LinearProgress from '@mui/material/LinearProgress';

import Box from '@mui/joy/Box';
import Card from '@mui/joy/Card';
import CardContent from '@mui/joy/CardContent';
import Typography from '@mui/joy/Typography';


import ReportIcon from '../../assets/reportIcon.svg'


////////////////////// API
import { getStatesNumber } from '../../Api/Statistics';



export default function ListReports() {
    const [states, setStates] = useState(null);
    const [loadingData, setLoadingData] = useState(false)

    const getListStates = useCallback(async () => {
        setLoadingData(true)
        const res = await getStatesNumber();
        if (res) {
            setLoadingData(false)
            setStates(res)
        }
    }, [])

    useEffect(() => {
        getListStates();
    }, [getListStates])

    return (
        <>
            <Box
                sx={{
                    width: '100%',
                    maxWidth: '100%',
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
                    gap: 2,
                    // justifyContent: 'stretch',
                    alignItems: 'stretch'
                }}
            >
                {/* {states.map((state) => {
                    return ( */}
                <Card variant="soft" sx={{ backgroundColor: '#FFF', position: 'relative', boxShadow: '0px 2px 2px 0px rgba(0, 0, 0, 0.08)' }}>
                    <CardContent>
                        <img src={ReportIcon} className='iconUserCard' alt='icon' />
                        <Typography level="p" sx={{ fontSize: '14px', color: '#5B6668' }}>عدد السيارات المقيمة</Typography>
                        <Typography level="h3" sx={{ fontSize: '22px', color: '#434448' }}>{states?.paymentCount}</Typography>
                    </CardContent>
                </Card>
                <Card variant="soft" sx={{ backgroundColor: '#FFF', position: 'relative', boxShadow: '0px 2px 2px 0px rgba(0, 0, 0, 0.08)' }}>
                    <CardContent>
                        <img src={ReportIcon} className='iconUserCard' alt='icon' />
                        <Typography level="p" sx={{ fontSize: '14px', color: '#5B6668' }}>عدد المعلنين</Typography>
                        <Typography level="h3" sx={{ fontSize: '22px', color: '#434448' }}>{states?.advertiseCount}</Typography>
                    </CardContent>
                </Card>
                <Card variant="soft" sx={{ backgroundColor: '#FFF', position: 'relative', boxShadow: '0px 2px 2px 0px rgba(0, 0, 0, 0.08)' }}>
                    <CardContent>
                        <img src={ReportIcon} className='iconUserCard' alt='icon' />
                        <Typography level="p" sx={{ fontSize: '14px', color: '#5B6668' }}>عدد التقيمات</Typography>
                        <Typography level="h3" sx={{ fontSize: '22px', color: '#434448' }}>{states?.ratesCount}</Typography>
                    </CardContent>
                </Card>
                {/* )
                })} */}
            </Box>
            {loadingData ? (
                <LinearProgress />
            ) : false}
        </>

    );
}